import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

export const DEFAULT_SETTINGS = {
  business: {
    brand_name: "HYPPE AROMA",
    tagline: "Enhance Your Natural Aura",
    founder: "Kruparth Pathak",
    email: "hyppearoma@gmail.com",
    phone: "+91 7201 07 0996",
    whatsapp: "917201070996",
    instagram: "hyppearoma",
    established: "2026",
    address_lines: ["Nirkunj, Anandnagar Road,", "Satellite, Ahmedabad,", "Gujarat 380015, India"],
  },
  homepage: {},
  brand_story: { paragraphs: [] },
  policies: {},
  shipping: { enabled: true, flat: 79, free_threshold: 999, tax_rate: 0 },
  seo: {},
  banners: {},
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const value = useMemo(() => ({ settings, loaded }), [settings, loaded]);

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  return ctx ? ctx.settings : DEFAULT_SETTINGS;
};
